import { Heading } from "@chakra-ui/react";
import React from "react";

function CustomHeading({
  family,
  size,
  weight,
  color,
  cursor,
  text,
  onClick,
}: any) {
  return (
    <Heading
      fontFamily={family || "DoubleBass"}
      fontSize={size || "16px"}
      fontWeight={weight || "normal"}
      color={color || "black"}
      cursor={cursor || "default"}
      userSelect={cursor ? "none" : "auto"}
      onClick={onClick}
      letterSpacing="0.5px"
    >
      <span className={family}>{text}</span>
    </Heading>
  );
}

export default CustomHeading;
